<template>
  <div class="role">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    />

    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :button-list="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :custom-visible="false"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left" />
        <vxe-table-column
          v-for="(item, index) in columns"
          :key="index"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.prop"
          :title="item.label"
        />
      </sirui-table>
    </div>
    <addRole ref="addRole" @getData="getData" />
    <editRole ref="editRole" @getData="getData" />
    <detailRole ref="detailRole" @getData="getData" />
  </div>
</template>
<script>
  import tableMixins from '@/common/mixins/table.js';
  import API from '@/api/systemManage/role.js';
  import addRole from './addModal/addRole';
  import editRole from './editModal/editRole';
  import detailRole from './detailModal/detailRole';

  export default {
    name: 'role',
    components: {
      addRole,
      editRole,
      detailRole,
    },
    mixins: [tableMixins],
    data() {
      return {
        load: false,
        query: {
          applicationCode: null,
          roleName: null,
        },
        applicationList: [],
        menuButtonList: [],
        tableData: [],
        multipleSelection: [],
      };
    },
    computed: {
      // 搜索字段
      searchColumns: {
        get() {
          return [
            {
              prop: 'applicationCode',
              name: this.$t('role.search.applicationName'),
              type: 'select',
              placeholder: this.$t('role.search.applicationPlaceholder'),
              options: this.applicationList,
            },
            {
              prop: 'roleName',
              name: this.$t('role.search.roleName'),
              type: 'input',
              placeholder: this.$t('role.search.rolePlaceholder'),
            },
          ];
        },
      },
      // 表格显示字段
      columns() {
        return [
          { prop: 'roleName', label: this.$t('role.table.roleName') },
          {
            prop: 'applicationName',
            label: this.$t('role.table.applicationName'),
          },
          { prop: 'remark', label: this.$t('role.table.remark') },
        ];
      },
    },
    /** 页面必要代码Start */
    mounted() {
      this.$nextTick(() => {
        this.queryApplication();
        this.getButtonList();
        this.getData();
      });
    },
    methods: {
      // 获取应用列表
      queryApplication() {
        this.$axios.post(API.GET_APP_LIST_API).then((res) => {
          if (res.data.code === 0) {
            res.data.data.forEach((item) => {
              item.label = item.applicationName;
              item.value = item.applicationCode;
            });
            this.applicationList = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 获取菜单按钮
      getButtonList() {
        this.menuButtonList = [
          {
            id: 1,
            label: '新增',
            type: '0',
            attributes: {
              buttonStyle: 'el-icon-plus',
              buttonName: '新增',
              buttonUrl: 'add',
            },
          },
          {
            id: 2,
            label: '删除',
            type: '0',
            attributes: {
              buttonStyle: 'el-icon-delete',
              buttonName: '删除',
              buttonUrl: 'del',
            },
          },
          {
            id: 3,
            label: '修改',
            type: '0',
            attributes: {
              buttonStyle: 'el-icon-edit',
              buttonName: '修改',
              buttonUrl: 'edit',
            },
          },
          {
            id: 4,
            label: '菜单授权',
            type: '0',
            attributes: {
              buttonStyle: 'el-icon-edit',
              buttonName: '菜单授权',
              buttonUrl: 'menuAuthorize',
            },
          },
        ];
      },
      // 获取数据
      getData() {
        const query = this.$refs.siruiSearch.query;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.load = true;
        this.$axios.post(API.GET_LIST_API, query).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 点击按钮触发的方法
      chooseClick(type) {
        if (type === 'add') {
          this.$refs.addRole.openDialog(true);
        }
        if (type === 'edit') {
          if (this.multipleSelection.length !== 1) {
            this.$message({
              showClose: true,
              message: this.$t('menu.editTreeTips'),
              type: 'error',
            });
            return;
          }
          this.$refs.editRole.openDialog(
            true,
            JSON.parse(JSON.stringify(this.multipleSelection[0]))
          );
        }
        if (type === 'menuAuthorize') {
          if (this.multipleSelection.length !== 1) {
            this.$message({
              showClose: true,
              message: this.$t('role.authRoleTips'),
              type: 'error',
            });
            return;
          }
          this.$refs.detailRole.openDialog(
            true,
            JSON.parse(JSON.stringify(this.multipleSelection[0]))
          );
        }
        if (type === 'del') {
          if (this.multipleSelection.length === 0) {
            this.$message({
              showClose: true,
              message: this.$t('role.deleteTips'),
              type: 'error',
            });
            return;
          }
          this.$confirmAction()
            .then(() => {
              const roles = [];
              this.multipleSelection.forEach((item) => {
                roles.push(item.roleCode);
              });
              this.loading.startLoading();
              this.$axios.post(API.DELETE_ROLE_API, { roles: roles.join(',') }).then((res) => {
                this.loading.endLoading();
                if (res.data.code === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$t('message.success'),
                  });
                  this.getData();
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        }
      },
    },
  };
</script>
